import React from "react";
import { useHistory } from "react-router-dom";

import { useForm } from "react-hook-form";

import { Button, TextField, Grid } from "@material-ui/core";

import { usePageLoader } from "../util/usePageLoader";
import { useAlert } from "../util/useAlert";

import * as Endpoints from "../util/Endpoints";
import * as ApiUtil from "../util/ApiUtil";

export const Login = (props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const history = useHistory();

  const [loader, showLoader, hideLoader] = usePageLoader();
  const [alert, showAlert] = useAlert();

  const loginUser = async (data) => {
    try {
      showLoader();
      const responseData = await ApiUtil.callBackend(Endpoints.login, "POST", {
        username: data.username,
        password: data.password,
      });
      console.log(responseData);

      if (responseData.status) {
        localStorage.setItem("token", responseData.data.token);
        localStorage.setItem("user", JSON.stringify(responseData.data.user));
        localStorage.setItem("token_date", new Date());
        localStorage.setItem("expire_in", responseData.data.expireIn); //Minutes
        localStorage.setItem(
          "role",
          JSON.stringify(responseData.data.user.role)
        );
        localStorage.setItem(
          "authorities",
          JSON.stringify(responseData.data.user.role.authorities)
        );
        history.push("/questionnaire");
      } else {
        showAlert(responseData.message, "error");
      }
    } catch (error) {
      console.log(error);
      showAlert(error.message, "error");
      return;
    } finally {
      hideLoader();
    }
  };

  return (
    <>


      {loader}
      {alert}
    </>
  );
};
